import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Events from './pages/Events';
import Shop from './pages/Shop';
import Careers from './pages/Careers';
import Academy from './pages/Academy';
import About from './pages/About';
import Blog from './pages/Blog';
import ArticlePage from './pages/ArticlePage';
import FilmPage from './pages/FilmPage';
import Contact from './pages/Contact';
import CarAlert from './pages/CarAlert';
import Community from './pages/Community';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import { Toaster } from './components/ui/toaster';
import WhatsAppButton from './components/WhatsAppButton';
import InquiryWidget from './components/InquiryWidget';

const AppRoutes = () => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  const isArticle = location.pathname.startsWith('/tales/');
  const showChrome = !isAdmin && !isArticle;

  useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);

  return (
    <>
      {showChrome && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/events" element={<Events />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/academy" element={<Academy />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/tales/the-forever-young-ferrari-sf90-spider" element={<FilmPage />} />
        <Route path="/tales/:slug" element={<ArticlePage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/car-alert" element={<CarAlert />} />
        <Route path="/community" element={<Community />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      {showChrome && <Footer />}
      {showChrome && <WhatsAppButton />}
      {showChrome && <InquiryWidget />}
      <Toaster />
    </>
  );
};

function App() {
  useEffect(() => {
    /* Remove platform badge from DOM entirely on hydration */
    const badge = document.getElementById('emergent-badge');
    if (badge) badge.remove();

    /* Replace generic noscript fallback with branded content */
    const noscripts = document.querySelectorAll('noscript');
    noscripts.forEach(ns => {
      if (ns.textContent.includes('enable JavaScript')) {
        ns.innerHTML = '<div style="font-family:Inter,-apple-system,sans-serif;text-align:center;padding:80px 24px;color:#1a1a1a"><h1 style="font-size:28px;font-weight:300;letter-spacing:0.12em;margin-bottom:16px">REVS VIBES</h1><p style="font-size:14px;color:#666">This site is best experienced with JavaScript enabled.</p></div>';
      }
    });
  }, []);

  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;